// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__28Ho0","error":"Textarea_error__3pETR","readonly":"Textarea_readonly__1LfUw","disabled":"Textarea_disabled__3M9U3"};